<template>
    <div class="
      absolute bottom-[10px] left-0 hidden w-full justify-center

      sm:flex

      xl-tall:bottom-[55px]
    ">
        <button v-for="thumbnail in thumbnails"
            :key="thumbnail.code"
            :title="thumbnail.label"
            :aria-label="thumbnail.label"
            class="
              relative size-[150px] rounded border-none transition-opacity duration-500 focus-outline-only

              xl-tall:size-[200px]
            "

            @click.prevent="clicked(thumbnail)"
        >
            <div class="absolute inset-0"
            >
                <div class="absolute inset-0 bg-gray-100"
                    :style="{
                        mask: `url(${thumbnail.preview})`,
                        maskSize: 'contain',
                    }"
                ></div>

                <div class="absolute inset-0"
                    :class="{
                        'opacity-50': !thumbnail.selected
                    }"
                >
                    <smooth-background :background="thumbnail.preview"
                    />
                </div>
            </div>
        </button>
    </div>
</template>

<script>
    import SmoothBackground from './UI/containers/SmoothBackground.vue';

    export default {
        components: {
            SmoothBackground,
        },

        props: {
            thumbnails: Array,
        },

        methods: {
            clicked(thumbnail) {
                this.$emit('selected', thumbnail.code);
            },
        },
    };
</script>
